import { EAPFeature } from '.';
import { ADMIN_FEATURE_SELECTION } from '../../../../routes';
import { prependAppPath } from '../../../services/Url';

export const features: EAPFeature[] = [
    {
        id: 'ai-coach',
        name: 'AI Coaches for Reviews and Training',
        description:
            'Upload company policies, values and career matrixes, then let interactive AI coaches help managers prepare for tough conversations, or write more relevant performance reviews',
        descriptionLong: (
            <>
                <h3>AI-driven manager coaching, AI guidance for your company's reviews</h3>
                <p>
                    <b>Help prepare for tough conversations</b>
                    <br />
                    New managers will face tricky situations, and AI can help prepare. But external tools like ChatGPT
                    won't have access to your company approach, values or policies — and you'd not want staff sharing
                    these externally unsupervised. Using SI, you can now upload your policies and resources, and then
                    offer AI-based training such as role-playing pay raise request, preparing for tricky discussions, or
                    collecting thoughts before reporting misconduct. Pre-uploaded resources ensure everything remains
                    true to your company approach.
                </p>
                <p>
                    <b>Guide reviews holistically</b>
                    <br />
                    In addition to our existing writing assistants, you can now guide managers and staff with
                    interactive coaches. These can make suggestions by comparing the current writing with previous
                    feedback and objectives, and ensure the review matches your career matrix or general world knowledge
                    about roles. See screenshot for an example.
                </p>
                <p>
                    <a href="https://www.small-improvements.com/features/ai-coach-overview/">
                        Learn more about the feature here
                    </a>
                    . To try things out{' '}
                    <a href={prependAppPath(ADMIN_FEATURE_SELECTION)}>go to the Feature Settings screen</a> and enable
                    the Coach in the AI section.
                </p>
            </>
        ),
        type: 'announcement',
        imgSrc: require('./images/ai-coach.png'),
    },
    {
        id: 'inbox',
        name: 'Inbox',
        description: 'Never miss notifications anymore thanks to the new Inbox',
        descriptionLong: (
            <>
                <p>
                    Notifications deserve a proper place on the main menu so that users can interact with the content
                    immediately. Your manager left a comment on your objective? Take note and reply right away.
                </p>
                <p>
                    Try our clickable prototype for 1:1s and Objectives, and let us know what’s important to you and
                    your employees.
                </p>
            </>
        ),
        type: 'preview',
        featureToggle: 'FEATURE_inboxPage',
        imgSrc: require('./images/inbox.png'),
        hideIfDisabled: true,
    },
    {
        id: 'boxes',
        name: 'Talent Box',
        description: 'Visualize your talent with 9-box grids or any two-axis framework built from your review data.',
        descriptionLong: (
            <>
                <p>
                    We're rolling out a new Talent Box view, now available in Early Access. Alongside existing charts
                    and graphs, it maps employees across two axes like potential and performance, or any two numeric
                    measures from your reviews. It supports classic 9-box frameworks, while staying flexible enough to
                    reflect how your organization actually evaluates talent.
                </p>
                <p>
                    If enabled, you will find the boxes in a new tab next to the charts in the performance review
                    overview.
                </p>
            </>
        ),
        type: 'preview',
        featureToggle: 'FEATURE_reviewOverviewBoxChart',
        imgSrc: require('./images/talent-boxes.png'),
    },
];
